import React, { useMemo, useState } from 'react';
import { getApiOrigin } from '../services/api';

export default function GalerieImagesProduit({ images }) {
  const imgs = useMemo(() => (Array.isArray(images) ? images : []), [images]);
  const [active, setActive] = useState(0);

  function normaliserUrlImage(url) {
    if (!url) return null;
    const s = String(url);
    if (s.startsWith('http://') || s.startsWith('https://')) return s;
    const origin = getApiOrigin().replace(/\/$/, '');
    if (s.startsWith('/uploads')) return `${origin}${s}`;
    if (s.startsWith('uploads/')) return `${origin}/${s}`;
    return s;
  }

  const current = normaliserUrlImage(imgs[active]?.url_image);

  return (
    <div className="grid gap-3">
      <div className="aspect-[4/3] overflow-hidden rounded-2xl border border-gray-200 bg-white">
        {current ? (
          <img src={current} alt="Produit" className="h-full w-full object-cover" />
        ) : (
          <div className="flex h-full w-full items-center justify-center text-xs text-slate-400">Aucune image</div>
        )}
      </div>
      <div className="flex gap-2 overflow-auto">
        {imgs.map((im, idx) => (
          <button
            key={im.id || idx}
            onClick={() => setActive(idx)}
            className={`h-16 w-20 overflow-hidden rounded-xl border ${
              idx === active ? 'border-marega-500' : 'border-gray-200'
            } bg-white`}
          >
            <img src={normaliserUrlImage(im.url_image) || ''} alt="Miniature" className="h-full w-full object-cover" />
          </button>
        ))}
      </div>
    </div>
  );
}
